import { authHeader } from "@/_helpers/auth-header";
import { handleResponse } from "@/_helpers/handle-response";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_ITTENTION;

export const reportService = {
  createReport,
  getReports,
  getReportBASIC,
  deleteReport,
  postReport,
  // setProject,
  deleteAOIReport,
  updateSaliencyName,
  getReportAOI
};

function createReport(data) {
  const requestOptions = {
    method: "post",
    url: "/processes/api/v1/saliencyreport/",
    data: {
      data: data
    },
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function getReports(media, limit, offset) {
  const requestOptions = {
    method: "get",
    url: "/processes/api/v1/saliencyreport/",
    params: {
      limit: limit,
      offset: offset,
      media: media
    },
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

// project get one

function getReportBASIC(uuid) {
  const requestOptions = {
    method: "get",
    url: "/processes/api/v1/saliencyreport/" + uuid,
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}
function getReportAOI(uuid) {
  const requestOptions = {
    method: "get",
    url: "/processes/api/v1/aoitestreport/" + uuid,
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}
function postReport(img) {
  const requestOptions = {
    method: "post",
    url: "/processes/api/v1/saliencyreport/",
    data: { name: img.name },
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function deleteReport(uuid) {
  const requestOptions = {
    method: "delete",
    url: "/processes/api/v1/saliencyreport/" + uuid,
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}


function deleteAOIReport(uuid) {
  const requestOptions = {
    method: "delete",
    url: "/processes/api/v1/aoitestreport/" + uuid,
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse => {
    })
    .catch(error => {
      return error
    });
}

function updateSaliencyName(uuid, newName) {
  const requestOptions = {
    method: "patch",
    url: "/processes/api/v1/saliencyreport/" + uuid,
    data: {name:newName},
    headers: {
      Authorization: authHeader().Authorization,
    },
  };
  return axios(requestOptions)
}